import { Box, CardActionArea, CardMedia, Chip, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state";
import { ActivityType } from "../../types/activityType";

interface ActivityCardProps {
    content: ActivityType;
}

export const ActivityCard = (props: ActivityCardProps) => {
    const theme = useTheme();
    // const currentStyle = withStyles(styles);
    const dispatch = useDispatch();
    const { setSelectedActivity } = bindActionCreators(actionCreators, dispatch);
    return (
        <Card>
            <Link to={`/activity/${props.content.id}`}>
                <CardActionArea onClick={(e) => setSelectedActivity(props.content)}>
                    {props.content.presentationImage !== undefined ? (
                        <>
                            <Box>
                                <Chip
                                    sx={{
                                        position: "absolute",
                                        zIndex: 10,
                                        right: theme.spacing(1),
                                        top: theme.spacing(1),
                                    }}
                                    color="primary"
                                    label={props.content.technology}
                                />
                                <CardMedia
                                    component="img"
                                    height="100%"
                                    image={props.content.presentationImage}
                                    alt="preview image"
                                    sx={{ height: "165px", objectFit: "cover" }}
                                />
                            </Box>
                        </>
                    ) : (
                        //(props.videoPath !== undefined) ?
                        //     <iframe
                        //         width="100%"
                        //         height="100%"
                        //         src={`https://www.youtube.com/embed/${props.videoPath}`}
                        //         // src={`http://i1.ytimg.com/vi/${props.videoPath}/0.jpg`}
                        //         frameBorder="0"
                        //         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        //         allowFullScreen
                        //         title="Embedded youtube"
                        //     /> :
                        <></>
                    )}
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {props.content.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {props.content.description}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Link>
        </Card>
    );
};
